<!-- <div class="header-top-app">
    <div class="content-app">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="text-start mt-2 mb-2">
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="text-end mt-2 mb-2">
                    <a routerLink="/login" class="btn btn-primary-theme btn-sm ms-2">
                        <i class="fa-solid fa-right-to-bracket"></i>
                        Iniciar sesión
                    </a>
                    <a routerLink="/home/register" class="btn btn-primary-theme btn-sm ms-2">
                        <i class="fa-solid fa-circle-user"></i>
                        Crear mi cuenta
                    </a>
                </div>
            </div>
        </div>
    </div>
</div> -->
<div class="header-app">
    <header class="content-app">
        <div class="row">
            <div class="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12">
                <div class="app-button-menu-main">
                    <button type="button" class="btn btn-light" (click)="toggleMenu()">
                        <i class="fa-solid fa-bars"></i>
                    </button>
                </div>
                <!-- <a routerLink="/" title="RedLaboralRD" class="d-block mt-1 mb-1 mx-auto" style="max-width: 400px;">
                    <img src="assets/Images/logo.jpg" class="img-fluid" alt="logo" />
                </a> -->
            </div>
            <div class="col-xxl-9 col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12">
                <ng-container *ngIf="isLogin == false">
                    <div class="text-end mt-2 mb-2">
                        <a routerLink="/login" class="btn btn-primary ms-2">
                            <i class="fa-solid fa-right-to-bracket"></i>
                            Iniciar sesión
                        </a>
                        <a routerLink="/home/register" class="btn btn-secondary ms-2">
                            <i class="fa-solid fa-circle-user"></i>
                            Crear mi cuenta
                        </a>
                         <!-- bandera/globo -->
                        <span class="ms-2">
                            <img *ngIf="countryCode === 'do'"
                                src="assets/flags/do.svg"
                                width="50"
                                height="30"
                                [title]="countryName"
                                alt="RD" />
                            <img *ngIf="countryCode === 'us'"
                                src="assets/flags/us.svg"
                                width="50"
                                height="30"
                                [title]="countryName"
                                alt="USA" />
                            <img *ngIf="countryCode !== 'do' && countryCode !== 'us'"
                                src="assets/flags/globe.svg"
                                width="50"
                                height="30"
                                [title]="countryName || 'Mundo'"
                                alt="Globo" />
                        </span>
                    </div>
                </ng-container>
                <ng-container *ngIf="isLogin">
                    <div class="text-end mt-2 mb-2">
                        <ng-container *ngIf="userRol == roles.Member">
                            <span class="badge rounded-pill text-bg-primary text-white fs-6 pb-2" [routerLink]="['/candidates/my-account']" style="cursor: pointer;">
                                <i class="fa-solid fa-circle-user"></i>
                              {{userFullName}}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="userRol == roles.Admin">
                            <span class="badge rounded-pill text-bg-primary text-white fs-6 pb-2" [routerLink]="['/admin/my-account']" style="cursor: pointer;">
                                <i class="fa-solid fa-circle-user"></i>
                              {{userFullName}}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="userRol == roles.Company">
                            <span class="badge rounded-pill text-bg-primary text-white fs-6 pb-2" [routerLink]="['/companies/my-account']" style="cursor: pointer;">
                                <i class="fa-regular fa-building"></i>
                                {{userFullName}}
                            </span>
                        </ng-container>
                        <button type="button" class="btn btn-danger rounded-pill btn-sm ms-2"  (click)="doLogout()" >
                            <i class="fa-regular fa-circle-xmark"></i>
                            Cerrar sesión
                        </button>
                        <!-- bandera/globo -->
                        <span class="ms-2">
                            <img *ngIf="countryCode === 'do'"
                                src="assets/flags/do.svg"
                                width="45"
                                height="25"
                                [title]="countryName"
                                alt="RD" />
                            <img *ngIf="countryCode === 'us'"
                                src="assets/flags/us.svg"
                                width="45"
                                height="25"
                                [title]="countryName"
                                alt="USA" />
                            <img *ngIf="countryCode !== 'do' && countryCode !== 'us'"
                                src="assets/flags/globe.svg"
                                width="45"
                                height="25"
                                [title]="countryName || 'Mundo'"
                                alt="Globo" />
                        </span>
                    </div>
                </ng-container>
                <ng-container >
                    <nav class="navbar navbar-expand-md mb-1 pt-0 pb-0 navbar-theme">
                        <div class="container-fluid">
                            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"></span>
                            </button>
                            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                                    <li class="nav-item" *ngIf="isLogin == false">
                                        <a class="nav-link" routerLink="/home" routerLinkActive="active">
                                            <i class="fa-solid fa-house"></i>
                                            Inicio
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" routerLink="/home/about" routerLinkActive="active">
                                            <i class="fa-regular fa-building"></i>
                                            Acerca de nosotros
                                        </a>
                                    </li>
                                    <!-- <li class="nav-item">
                                        <a class="nav-link" routerLink="/home/shop" routerLinkActive="active">
                                            <i class="fa-solid fa-store"></i>
                                            Tienda
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" routerLink="/home/becas" routerLinkActive="active">
                                            <i class="fa-solid fa-graduation-cap"></i>
                                            Becas
                                        </a>
                                    </li> -->
                                   

                                </ul>
                            </div>
                        </div>
                    </nav>
                </ng-container>
                <ng-container *ngIf="isLogin">
                    <nav class="navbar navbar-expand-md mb-1 pt-0 pb-0 navbar-theme">
                        <div class="container-fluid">
                            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"></span>
                            </button>
                            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                                    <ng-container *ngIf="userRol == roles.Member">
                                        <!-- <li class="nav-item">
                                            <a class="nav-link" routerLink="/candidates/main" routerLinkActive="active">
                                                <i class="fa-solid fa-house"></i>
                                                Inicio
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" routerLink="/candidates/my-cvs" routerLinkActive="active">
                                                <i class="fa-regular fa-address-card"></i>
                                                Mis Curriculum
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" routerLink="/candidates/job-offers" routerLinkActive="active">
                                                <i class="fa-solid fa-briefcase"></i>
                                                Ofertas laborales
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" routerLink="/candidates/my-account" routerLinkActive="active">
                                                <i class="fa-solid fa-id-card-clip"></i>
                                                Mi Cuenta
                                            </a>
                                        </li> -->
                                    </ng-container>
                                    <ng-container *ngIf="userRol == roles.Company">
                                        <!-- <li class="nav-item">
                                            <a class="nav-link" routerLink="/companies/main" routerLinkActive="active">
                                                <i class="fa-solid fa-house"></i>
                                                Inicio
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" routerLink="/companies/job-offers" routerLinkActive="active">
                                                <i class="fa-solid fa-briefcase"></i>
                                                Ofertas laborales
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" routerLink="/companies/my-account" routerLinkActive="active">
                                                <i class="fa-solid fa-id-card-clip"></i>
                                                Mi Cuenta
                                            </a>
                                        </li> -->
                                    </ng-container>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </ng-container>
            </div>
        </div>
    </header>
</div>